<template>
  <div class="overlay-confetti">
    <canvas ref="bgConfetti" ></canvas>
  </div>
</template>

<script>
import ConfettiGenerator from 'confetti-js';

export default {
  name: 'ConfettiBackground',
  mounted() {
    const confetti = new ConfettiGenerator({
      target: this.$refs.bgConfetti,
      max: '150',
      size: '2',
      props: ['circle', 'square', 'triangle'],
      start_from_edge: true,
    });
    setTimeout(confetti.render, 1000);
    this.confetti = confetti;
  },
  destroyed() {
    this.confetti.clear();
  },
  data: () => ({
    confetti: undefined,
  }),
};
</script>

<style scoped lang="sass">
.overlay-confetti
  position: fixed
  top: 0
  left: 0
  bottom: 0
  right: 0
</style>
